import { render, staticRenderFns } from "./colorCards.vue?vue&type=template&id=39c5188e&scoped=true"
import script from "./colorCards.vue?vue&type=script&lang=ts"
export * from "./colorCards.vue?vue&type=script&lang=ts"
import style0 from "./colorCards.vue?vue&type=style&index=0&id=39c5188e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c5188e",
  null
  
)

export default component.exports